const THIRTY_DAYS_IN_SECONDS = 3600 * 24 * 30

// The `lt_token` cookie is a shared contract with other Logtrade front-ends
// (session sharing within Logtrade subdomains). It must keep the exact name and
// attributes used by @logtrade-technology-ab/logtrade-lib, which this module
// replaces — do not rename or change attributes without checking the other apps.
const saveToken = (token: string, remember: boolean) => {
  document.cookie = `lt_token=${token}; path=/; Secure; SameSite;${
    remember ? ` max-age=${THIRTY_DAYS_IN_SECONDS};` : ''
  }`
}

const removeToken = () => {
  document.cookie = `lt_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite`
}

const readToken: () => string | undefined = () =>
  document.cookie
    .split('; ')
    ?.find((row) => row.startsWith('lt_token='))
    ?.split('=')[1]

const cookieHandler = {
  saveToken,
  removeToken,
  readToken,
}

export default cookieHandler
